import { memo, useEffect, useState } from "react";
import HistoryBodyDesktop from "./Desktop/HistoryBodyDesktop";
const HistoryBody = () => {
    return (
        <>
            <HistoryBodyDesktop />
        </>
    )
}
export default HistoryBody;